import PropTypes from 'prop-types'
import Error from '../../../common/ErrorMessage'
import MCElement from '../../../common/MCElement'

import '../configPageItem/ConfigPageItem.scss'
import './ConfigPageItemCustom.scss'
import ConfigPageCustomItemPreview from './ConfigPageCustomItemPreview'

const ConfigPageCustomItem = ({
  screenName,
  screenDesc,
  screenTitle,
  checked,
  handleCheck,
  thumbnail,
  needFileUpload,
  openImageBank,
  imgSelection,
}) => (
  <div className='config-item'>
    <MCElement
      type='checkbox'
      isSelected={checked}
      clicked={() => handleCheck(screenTitle)}
    />

    <img
      src={thumbnail}
      alt={screenTitle + ' thumbnail'}
      className='config-item-preview-img'
    />
    <div>
      <h3 className='config-item-label'>{screenName}</h3>
      <p className='config-item-desc'>{screenDesc}</p>
      <div className='config-item-image-array'>
        <ConfigPageCustomItemPreview />
        <button onClick={openImageBank} className='no-bg-text-btn'>
          {imgSelection.length > 0 ? 'Edit selection' : 'Choose images'}
        </button>
      </div>
      {checked && needFileUpload ? (
        <div className='config-item-error-msg'>
          <Error error='Please choose at least 1 image to display' />
        </div>
      ) : null}
    </div>
  </div>
)

ConfigPageCustomItem.propTypes = {
  checked: PropTypes.bool,
  needFileUpload: PropTypes.bool,
  imgSelection: PropTypes.array,
  screenName: PropTypes.string,
  screenTitle: PropTypes.string,
  screenDesc: PropTypes.string,
  thumbnail: PropTypes.string,
  openImageBank: PropTypes.func,
  handleCheck: PropTypes.func,
}

export default ConfigPageCustomItem
